<button class="share d-flex align-items-center px-3 py-2 my-2" (click)="sharePlanLoginModal()">
  <img class="small-icon" src="./assets/img/common/share.svg" alt="">
  <div class="d-flex justify-content-center flex-grow-1">
    <span>SHARE THIS PLAN</span>
  </div>
</button>